// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"483":"27fd3c43","496":"25754889"}[chunkId] + ".chunk.js";
};